import React from 'react';
import ContentEditable from 'react-contenteditable'
import { loadMeowContract } from '../util/StandardGetters.js'

async function loadVoteData([user]) {
  const { contract: meow } = await loadMeowContract([user]);

  let staked = meow.methods.currentlyStaked(user).call();

  let voteWeight = meow.methods.voteWeights(user).call(); 
  let currentVote = meow.methods.currentVotes(user).call();

  [staked, voteWeight, currentVote] =
    await Promise.all([staked, voteWeight, currentVote]);

  return {
    meow,

    staked,
    voteWeight,
    currentVote
  };
}

export const requiredData = {
  name: 'vote',
  get: loadVoteData
}

export default class Vote extends React.Component {
  constructor(props) {
    super(props);
    this.ceRef = React.createRef();

    let { meow, staked, voteWeight, currentVote } = props.vote;

    this.meow = meow;
    this.staked = staked;
    this.voteWeight = voteWeight.toString();
    this.currentVote = currentVote;

    this.extractor = document.createElement('span');
    this.from = { from: props.accounts[0] };

    this.state = {
      votingFor: '',
      loading: false,
      mustRebuild: false,
    }
  }

  componentDidMount = () => {
    if (this.staked) {
      this.ceRef.current.focus();
    }
  }

  extractContent = s => {
    this.extractor.innerHTML = s;
    return this.extractor.innerText;
  }

  updateVote = (e) => {
    this.setState({ votingFor: this.extractContent(e.target.value)});
  }

  castVote = withRebuild => withRebuild ?
    this.meow.methods.voteWithRebuildIfNecessary(this.state.votingFor).send(this.from) :
    this.meow.methods.voteForAddress(this.state.votingFor).send(this.from)

  onVote = async () => {
    if (this.state.loading) return;

    let address = this.state.votingFor.trim();
    if (window.web3.utils.isAddress(address)) {
      this.setState({loading: true});

      const { meow }  = this;

      let itLen = await meow.methods.voteIteratorLength().call();
      itLen = itLen.toNumber();

      if (itLen < 12) return this.castVote(false);

      let candidates = []
      for (let i = 0; i < itLen; i++) {
        candidates.push(meow.methods.voteIterator(i).call())
      }

      candidates = await Promise.all(candidates);

      if (candidates.find(a => a === this.state.votingFor)) return this.castVote(false);

      this.setState({mustRebuild: true});
    }
  }

  onVoteWithRebuild = () => this.castVote(true);

  render = () =>
    <>
      <h1>Vote for address</h1>
      {this.staked ?
        <>
          {this.voteWeight !== '0' &&
            <small>Current Vote {this.currentVote}</small>
          }
          <div>
            <ContentEditable
              className='cleanInput small-margin extra-wide'
              innerRef={this.ceRef}
              html={this.state.votingFor}
              disabled={false}
              onChange={this.updateVote}
            />
          </div>
          {this.state.loading ?
            <span className='basic-button disabled no-margin'>~~~~~</span> :
            <span className='basic-button no-margin' onClick={this.onVote}>-></span>
          }
          {this.state.mustRebuild &&
            <>
              <div className='extra-margin'>
              This vote would likely overflow the candidates list. Rebuilding the
              list along with this vote will cost more gas than usual.
              </div>
              <span className='basic-button no-margin' onClick={this.onVoteWithRebuild}>-></span>
            </>
          }
        </> :
        <>
          Your wallet must be staked to vote.
        </>
      }
    </>
}
